import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { calculateTimePassed } from "../../shared/utils";
import StarRating from "../Common/StarRating";
import ReadMore from "../Common/ReadMore";
import { SortReview } from "./SortReview";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useCurrentViewportView } from "../../hooks/useCurrentViewportView";
import SelectBox from "../Common/SelectBox";

const ReviewContent = ({ reviews, type }) => {
  const [parent] = useAutoAnimate();
  const { isMobile } = useCurrentViewportView();

  return (
    <ul
      ref={parent}
      className="flex flex-col gap-8 max-h-[400px] overflow-y-auto pr-4"
    >
      {SortReview(reviews, type).map((review) => (
        <li
          key={review.id}
          className="flex gap-5 md:gap-7 p-3 bg-gradient-to-l from-transparent to-gray-darken/60 rounded-md hover:brightness-125 transition duration-300"
        >
          <div className="shrink-0 max-w-[60px] w-full h-[60px]">
            <LazyLoadImage
              src="/avatarTest.jpg"
              alt="reviewer"
              effect="opacity"
              className="w-[60px] h-[60px] rounded-full object-cover"
            />
          </div>
          <div className="flex-grow">
            <div className="flex justify-between">
              <p className="text-gray-200 group-hover:text-white">
                {review.author}
              </p>
              {!isMobile ? (
                <StarRating
                  star={Math.round(review.author_details.rating / 2)}
                  maxStar={5}
                />
              ) : (
                <div className="flex">
                  <p className="text-white">
                    {Math.round(review.author_details.rating / 2)}
                  </p>
                  <div className="mt-1.5 ml-1">
                    <StarRating star={1} />
                  </div>
                </div>
              )}
            </div>
            <ReadMore limitTextLength={150}>{review.content}</ReadMore>
            <p className="text-right text-base">
              {calculateTimePassed(new Date(review.created_at).getTime())}
            </p>
          </div>
        </li>
      ))}
    </ul>
  );
};

const ReviewTab = ({ reviews }) => {
  const [reviewSortType, setReviewSortType] = useState("desc");

  const options = [
    { value: "asc", label: "Ascending" },
    { value: "desc", label: "Descending" },
  ];

  return (
    <>
      <div className="flex gap-4 justify-end items-center -mt-5 mb-10">
        <p>Sort Rating: </p>
        <SelectBox
          options={options}
          defaultValue={options.find(
            (option) => option.value === reviewSortType
          )}
          onChange={(e) => setReviewSortType(e?.value)}
          type="dark"
        />
      </div>
      <div>
        {!reviews && (
          <p className="text-center text-white text-lg">Loading Reviews.</p>
        )}
        {reviews.length === 0 && (
          <p className="text-center text-white text-lg">
            There is no reviews yet.
          </p>
        )}
        {reviews.length > 0 && (
          <ReviewContent reviews={reviews} type={reviewSortType} />
        )}
      </div>
    </>
  );
};

export default ReviewTab;
